<template>
  <span class="line-state icon iconfont icon-on-line" :class="styleClass"></span>
</template>

<script>
export default {
  props: {
    state: {
      type: Number,
      default: -1
    }
  },
  computed: {
    styleClass() {
      if (this.state === undefined || this.state === -1) {
        return 'off-color';
      } else if (this.state === 0) {
        return 'on-color';
      } else if (this.state === 1) {
        return 'warn-color';
      } else if (this.state === 2) {
        return 'danger-color';
      } else if (this.state === 71) {
        return 'fault-color';
      }
      return 'off-color';
    }
  }
};
</script>

<style lang="scss" scoped>
.line-state {
  &.on-color {
    color: $success-color;
  }
  &.off-color {
    color: $unconnect-color;
  }
  &.warn-color {
    color: $warn-color;
  }
  &.danger-color {
    color: $danger-color;
  }
  &.fault-color {
    color: $fault-color;
  }
}
</style>
